import { useAuth } from '@/contexts/AuthContext';
import { DenseModification, Board } from '@/types';
import { ModificationHistoryComponent } from './ModificationHistory.component';

interface ModificationHistoryProps {
  modifications: DenseModification[];
  board: Board | null;
  onClose: () => void;
}

export const ModificationHistory: React.FC<ModificationHistoryProps> = ({
  modifications,
  board,
  onClose,
}) => {
  const { user } = useAuth();

  return (
    <ModificationHistoryComponent
      modifications={modifications}
      board={board}
      currentUserId={user?.uid}
      onClose={onClose}
    />
  );
};

